/**
 * Size the Loan / Servicing / Sub-Status select so longer admin labels (e.g. "Pre-Close Review")
 * fit without clipping. Grow with the selected text up to a cap; nudge the font down a touch
 * when the label is still long for the room we allow.
 */
export function statusSelectFit(label: string, size: number = 5) {
  const text = String(label || '')
  const minCh = size === 4 ? 14 : 16
  const widthCh = Math.max(minCh, Math.min(32, text.length + 5))
  const textClass =
    text.length > 20
      ? '[&_select]:text-[12px] [&_select]:whitespace-nowrap'
      : text.length > 15
      ? '[&_select]:text-[13px] [&_select]:whitespace-nowrap'
      : '[&_select]:whitespace-nowrap'
  return { widthCh, textClass }
}
